export default __webpack_public_path__ + "static/media/gecko.3433f9bb.gif";